import {Variants} from 'framer-motion';

type ComesInViewFrom = 'left' | 'right' | 'top' | 'bottom';

const basicVariants: Variants = {
  offscreen: {},
  onscreen: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

function createVariants(comesInViewFrom: ComesInViewFrom): Variants {
  const transitions = {
    left: {x: -50, opacity: 0},
    right: {x: 50, opacity: 0},
    top: {y: -40, opacity: 0},
    bottom: {y: 40, opacity: 0},
  };

  const variants = {...basicVariants};
  variants.offscreen = {...transitions[comesInViewFrom]};

  return variants;
}

export {createVariants, ComesInViewFrom};
